import { cva } from "class-variance-authority"

export const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap font-heading font-semibold transition-all duration-300 focus:outline-none disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground shadow-visagio hover:bg-primary/90 hover:shadow-visagio-lg hover:-translate-y-0.5",
        destructive: "bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90",
        outline: "border-2 border-visagio-teal bg-white text-visagio-teal hover:bg-visagio-teal hover:text-white",
        secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80",
        ghost: "hover:bg-visagio-teal/10 hover:text-visagio-teal",
        link: "text-visagio-aqua underline-offset-4 hover:underline",
        "visagio-primary": "bg-visagio-teal text-white shadow-visagio hover:bg-visagio-teal-dark hover:shadow-visagio-lg hover:-translate-y-0.5 focus:ring-2 focus:ring-visagio-teal focus:ring-offset-2",
        "visagio-secondary": "bg-white text-visagio-teal border-2 border-visagio-teal hover:bg-visagio-teal hover:text-white focus:ring-2 focus:ring-visagio-teal focus:ring-offset-2",
        "visagio-mint": "bg-visagio-mint text-emerald-900 shadow-visagio hover:bg-visagio-aqua hover:text-white hover:-translate-y-0.5 focus:ring-2 focus:ring-visagio-mint focus:ring-offset-2",
        "visagio-aqua": "bg-visagio-aqua text-white shadow-visagio hover:bg-visagio-teal hover:-translate-y-0.5 focus:ring-2 focus:ring-visagio-aqua focus:ring-offset-2",
        "visagio-ghost": "bg-transparent text-visagio-teal hover:bg-visagio-teal/10",
        "visagio-dark": "bg-visagio-teal-dark text-white shadow-visagio-lg hover:bg-visagio-teal hover:-translate-y-0.5",
      },
      size: {
        default: "h-10 px-5 py-2 text-sm rounded-full",
        sm: "h-9 px-4 text-xs rounded-full",
        lg: "h-12 px-8 text-base rounded-full",
        xl: "h-14 px-10 text-lg rounded-full",
        icon: "h-10 w-10 rounded-full",
        "icon-sm": "h-8 w-8 rounded-full",
        "icon-lg": "h-12 w-12 rounded-full",
        "rect-sm": "h-9 px-4 text-xs rounded-visagio",
        "rect-default": "h-10 px-5 text-sm rounded-visagio",
        "rect-lg": "h-12 px-8 text-base rounded-visagio",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)
